import { render, staticRenderFns } from "./QnAModerationLink.vue?vue&type=template&id=a1b2e570&scoped=true"
import script from "./QnAModerationLink.vue?vue&type=script&lang=js"
export * from "./QnAModerationLink.vue?vue&type=script&lang=js"
import style0 from "./QnAModerationLink.vue?vue&type=style&index=0&id=a1b2e570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b2e570",
  null
  
)

export default component.exports